import "./singleplayer.278b3a44.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aRPiL = parcelRequire("aRPiL");
class $3377a5afbb92eb27$export$5169756de15f281f {
    socket;
    currentPromiseInput;
    constructor(socket){
        this.socket = socket;
        this.currentPromiseInput = null;
        this.socket.addEventListener("message", (event)=>{
            let data = JSON.parse(event.data);
            console.log("Message from server ", event.data);
            if (data.type == "GameEvent") {
                if (this.currentPromiseInput != null) {
                    this.currentPromiseInput.resolve(data.event);
                    this.currentPromiseInput = null;
                } else {
                    console.error("Received game data but no promise is queued");
                    console.error({
                        data: data
                    });
                }
            } else if (data.type == "GameError") {
                if (this.currentPromiseInput != null) {
                    this.currentPromiseInput.reject(data.error);
                    this.currentPromiseInput = null;
                } else {
                    console.error("Received error game data but no promise is queued");
                    console.error({
                        data: data
                    });
                }
            }
        });
    }
    register_promise(resolve, reject, type) {
        const newPromise = {
            resolve: resolve,
            reject: reject,
            type: type
        };
        if (this.currentPromiseInput != null) {
            console.error("We are setting a new promise before the current one has resolved");
            console.error("Current promise: ", this.currentPromiseInput);
            console.error("New promise: ", newPromise);
        // Some of the rejects take statements from the server and log them; maybe don't send this to reject
        //this.currentPromiseInput.reject("New promise was registered");
        }
        this.currentPromiseInput = newPromise;
    }
    add_to_dictionary(word) {
        return new Promise((resolve, reject)=>{
            this.register_promise(resolve, reject, "AddToDictionary");
            let event = {
                type: "GameMove",
                move: {
                    type: "AddToDictionary",
                    word: word
                }
            };
            this.socket.send(JSON.stringify(event));
        }).then((game_event)=>{
            return game_event.state;
        });
    }
    exchange(selection) {
        return new Promise((resolve, reject)=>{
            this.register_promise(resolve, reject, "Exchange");
            let event = {
                type: "GameMove",
                move: {
                    type: "Exchange",
                    tiles: selection
                }
            };
            this.socket.send(JSON.stringify(event));
        }).then((game_event)=>{
            return game_event.state;
        });
    }
    load(wait) {
        return new Promise((resolve, reject)=>{
            this.register_promise(resolve, reject, `Load with wait=${wait}`);
            if (!wait) {
                let event = {
                    type: "Load"
                };
                this.socket.send(JSON.stringify(event));
            }
        }).then((game_event)=>{
            return game_event.state;
        });
    }
    pass() {
        return new Promise((resolve, reject)=>{
            this.register_promise(resolve, reject, "Pass");
            let event = {
                type: "GameMove",
                move: {
                    type: "Pass"
                }
            };
            this.socket.send(JSON.stringify(event));
        }).then((game_event)=>{
            return game_event.state;
        });
    }
    play(tiles, commit) {
        return new Promise((resolve, reject)=>{
            this.register_promise(resolve, reject, "Play");
            let event = {
                type: "GameMove",
                move: {
                    type: "Play",
                    played_tiles: tiles,
                    commit_move: commit
                }
            };
            this.socket.send(JSON.stringify(event));
        }).then((game_event)=>{
            return game_event.state;
        });
    }
}



var $3pMtJ = parcelRequire("3pMtJ");

var $5m6zs = parcelRequire("5m6zs");
// Useful to set when debugging
// Set to empty string in production
//const SERVER_HOST = 'http://localhost:8000';
const $37ae1da3236643c2$var$SERVER_HOST = "";
function $37ae1da3236643c2$export$d9b273488cd8ce6f() {
    const [roomName, setRoomName] = (0, $acw62.useState)("");
    const [socket, setSocket] = (0, $acw62.useState)(null);
    const [partyInfo, setPartyInfo] = (0, $acw62.useState)(null);
    const [playerName, setPlayerName] = (0, $acw62.useState)("");
    const gameAPI = (0, $acw62.useRef)(null);
    const [game, setGame] = (0, $acw62.useState)(null);
    const validSettings = roomName.length > 0 && !roomName.includes("/") && playerName.length > 0 && !playerName.includes("?") && !playerName.includes("&");
    if (game) return game;
    else if (socket != null && partyInfo == null) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
            children: [
                "Connecting to ",
                roomName
            ]
        })
    });
    else if (partyInfo != null) return /*#__PURE__*/ (0, $ayMG0.jsxs)("dialog", {
        open: true,
        className: "multiplayer-lobby",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                children: [
                    "Connected to ",
                    roomName
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5m6zs.Lobby), {
                players: partyInfo.players,
                ais: partyInfo.ais,
                addAI: (x)=>{
                    const event = {
                        type: "AddAI",
                        difficulty: x
                    };
                    socket.send(JSON.stringify(event));
                },
                deleteAI: (i)=>{
                    const event = {
                        type: "RemoveAI",
                        index: i
                    };
                    socket.send(JSON.stringify(event));
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex-container",
                style: {
                    paddingTop: "1em"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>{
                            socket.close();
                            setSocket(null);
                            setPartyInfo(null);
                            gameAPI.current = null;
                        },
                        children: "Disconnect"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>{
                            const event = {
                                type: "StartGame"
                            };
                            socket.send(JSON.stringify(event));
                        },
                        children: "Start Game"
                    })
                ]
            })
        ]
    });
    else return /*#__PURE__*/ (0, $ayMG0.jsx)("dialog", {
        open: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "multiplayer-inputs-grid",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                    children: [
                        "Room Name:",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            type: "text",
                            value: roomName,
                            onChange: (e)=>{
                                setRoomName(e.target.value);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                    children: [
                        "Player Name:",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            type: "text",
                            value: playerName,
                            onChange: (e)=>{
                                setPlayerName(e.target.value);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    disabled: !validSettings,
                    onClick: ()=>{
                        let socket = new WebSocket(`${$37ae1da3236643c2$var$SERVER_HOST}/room/${roomName}?player_name=${playerName}`);
                        socket.addEventListener("message", (event)=>{
                            const input = JSON.parse(event.data);
                            if (input.type == "RoomChange") setPartyInfo(input.info);
                            else if (input.type == "GameEvent" && game == null) {
                                // start game
                                if (gameAPI.current == null) gameAPI.current = new (0, $3377a5afbb92eb27$export$5169756de15f281f)(socket);
                                setGame(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3pMtJ.Game), {
                                    api: gameAPI.current,
                                    settings: {
                                        playerName: playerName,
                                        trayLength: 7
                                    },
                                    end_game_fn: function() {
                                        socket.close();
                                        setSocket(null);
                                        setPartyInfo(null);
                                        setGame(null);
                                        gameAPI.current = null;
                                    }
                                }));
                            } else if (input.type == "Disconnection") {
                                socket.close();
                                alert(`Disconnected with reason: ${input.reason}`);
                            } else {
                                console.error("Received error type message from server");
                                console.error({
                                    input: input
                                });
                                socket.close(1001, "Received some kind of error; see logs");
                            }
                        //console.log("Message from server ", event.data);
                        });
                        socket.addEventListener("close", (event)=>{
                            console.log({
                                event: event
                            });
                            setSocket(null);
                            setPartyInfo(null);
                            setGame(null);
                            gameAPI.current = null;
                            if (event.reason != null && event.reason.length > 0) alert(`Disconnected with reason "${event.reason} & code ${event.code}"`);
                        });
                        setSocket(socket);
                    },
                    children: "Connect"
                })
            ]
        })
    });
}
async function $37ae1da3236643c2$var$run() {
    const root = (0, $aRPiL.createRoot)(document.getElementById("root"));
    root.render(/*#__PURE__*/ (0, $ayMG0.jsx)($37ae1da3236643c2$export$d9b273488cd8ce6f, {}));
}
$37ae1da3236643c2$var$run();


//# sourceMappingURL=multiplayer.34c9bd59.js.map
